module.exports = __webpack_public_path__ + "img/settings-window.0838fdd3.png";